/* Banana Manor size finder.

   Size is where buyers stall on a one-of-one rug: there is no second chance to order the
   same thing a foot wider. This answers "will it fit" from the room and the furniture,
   using the designer rules of thumb, and never dead-ends: a miss routes to the size that
   does fit, either in stock or made to order.

   Dimensions come from the product title, which is where this shop keeps them, written
   feet.inches - so "14.4x19.9" is 14'4" by 19'9", not 14.4 by 19.9. */
(function () {
  var BEDS   = { twin: [38, 75], full: [54, 75], queen: [60, 80], king: [76, 80], cal: [72, 84] };
  var TABLES = { '4': [36, 48], '6': [40, 72], '8': [44, 96], '10': [44, 120] };
  var DESKS  = { d60: 60, d72: 72, d72p: 84 };
  var SOFA   = { s72: 66, s84: 84, s96: 96, s96p: 108, sect: 110 };
  var STOCK  = [[3,5],[4,6],[5,8],[6,9],[8,10],[9,12],[10,14],[12,15]];

  /* Recommendations link to the size collection that actually holds them. */
  function collectionFor(w, l) {
    var area = w * l;
    if (Math.max(w, l) / Math.min(w, l) >= 2.6) return '/collections/runners';
    if (area < 20)  return '/collections/small-rugs';
    if (area < 56)  return '/collections/medium-rugs';
    if (area < 110) return '/collections/large-rugs';
    return '/collections/oversize-rugs';
  }

  function ft(inches) {
    var f = Math.floor(inches / 12), i = Math.round(inches - f * 12);
    if (i === 12) { f += 1; i = 0; }
    return i ? f + "'" + i + '"' : f + "'";
  }

  /* feet.inches -> inches. A decimal of 1-11 is inches; anything else is a real fraction. */
  function toInches(whole, dec) {
    var n = parseInt(whole, 10) * 12;
    if (!dec) return n;
    var d = parseInt(dec, 10);
    return n + (d >= 1 && d <= 11 ? d : Math.round(parseFloat('0.' + dec) * 12));
  }

  function parseSize(title) {
    var m = /(\d{1,2})(?:\.(\d{1,2}))?\s*[xX×]\s*(\d{1,2})(?:\.(\d{1,2}))?/.exec(title || '');
    if (!m) return null;
    var a = toInches(m[1], m[2]), b = toInches(m[3], m[4]);
    if (a < 12 || b < 12 || a > 360 || b > 480) return null;
    return { w: Math.min(a, b), l: Math.max(a, b) };
  }

  function bestStock(needW, needL, minShort, minLong) {
    var c = STOCK.filter(function (s) {
      if (minShort && (s[0] * 12 <= minShort || s[1] * 12 <= minLong)) return false; // must be a step UP
      return s[0] * 12 >= needW && s[1] * 12 >= needL;
    });
    c.sort(function (a, b) { return a[0] * a[1] - b[0] * b[1]; });
    return c[0] || STOCK.slice().sort(function (a, b) { return b[0] * b[1] - a[0] * a[1]; })[0];
  }

  function plan(roomW, roomL, rugW, rugL, recW, recL) {
    var pad = 12, W = 460, sc = (W - pad * 2) / Math.max(roomW, 1), H = roomL * sc + pad * 2 + 18;
    function rect(x, y, w, l, fill, stroke, dash) {
      return '<rect x="' + (pad + x * sc).toFixed(1) + '" y="' + (pad + y * sc).toFixed(1) +
        '" width="' + (w * sc).toFixed(1) + '" height="' + (l * sc).toFixed(1) +
        '" fill="' + fill + '" stroke="' + stroke + '" stroke-width="2"' +
        (dash ? ' stroke-dasharray="6 4"' : '') + '/>';
    }
    var s = '<svg viewBox="0 0 ' + W + ' ' + H.toFixed(0) + '" role="img" aria-label="Plan view of your room with this rug placed">';
    s += rect(0, 0, roomW, roomL, '#ffffff', '#ded5c4');
    if (recW) s += rect((roomW - recW) / 2, (roomL - recL) / 2, recW, recL, 'none', '#b5683c', true);
    s += rect((roomW - rugW) / 2, (roomL - rugL) / 2, rugW, rugL, 'rgba(43,43,43,.14)', '#2b2b2b');
    s += '<text x="' + (W / 2) + '" y="' + (H - 4).toFixed(0) + '" text-anchor="middle" font-size="11" fill="#6e6579">' +
      'your room ' + roomW + ' x ' + roomL + ' ft' + (recW ? '  ·  dashed = recommended ' + recW + ' x ' + recL : '') + '</text>';
    return '<div class="bm-sf-plan">' + s + '</svg></div>';
  }

  function init(root) {
    var size = parseSize(root.getAttribute('data-title'));
    if (!size) { root.setAttribute('hidden', ''); return; }   // no size in the title, no finder
    var label = ft(size.w) + ' x ' + ft(size.l);
    var q = function (s) { return root.querySelector(s); };
    var trigger = q('.bm-sf-trigger'), panel = q('.bm-sf-panel'), res = q('.bm-sf-res');
    var third = q('.bm-sf-third');

    function room() { var r = q('input[name="bm-sf-room"]:checked'); return r ? r.value : 'living'; }

    function syncThird() {
      var r = room(), h = '';
      if (r === 'living')  h = '<span class="bm-sf-q">How long is your sofa?</span><select class="bm-sf-sel">' +
        '<option value="s72">Under 72 in</option><option value="s84" selected>72 to 84 in</option>' +
        '<option value="s96">84 to 96 in</option><option value="s96p">Over 96 in</option><option value="sect">Sectional</option></select>';
      if (r === 'bedroom') h = '<span class="bm-sf-q">Bed size?</span><select class="bm-sf-sel">' +
        '<option value="twin">Twin</option><option value="full">Full</option><option value="queen" selected>Queen</option>' +
        '<option value="king">King</option><option value="cal">California King</option></select>';
      if (r === 'dining')  h = '<span class="bm-sf-q">How many chairs?</span><select class="bm-sf-sel">' +
        '<option value="4">4</option><option value="6" selected>6</option><option value="8">8</option><option value="10">10 or more</option></select>';
      if (r === 'hall')    h = '<span class="bm-sf-q">How wide is the hallway, in inches?</span>' +
        '<input class="bm-sf-sel" type="number" value="42" min="24" max="120">';
      if (r === 'office')  h = '<span class="bm-sf-q">Desk width?</span><select class="bm-sf-sel">' +
        '<option value="d60">Under 60 in</option><option value="d72" selected>60 to 72 in</option><option value="d72p">Over 72 in</option></select>';
      third.innerHTML = h;
    }

    function evaluate() {
      var r = room();
      var rw = parseFloat(q('.bm-sf-w').value) || 12, rl = parseFloat(q('.bm-sf-l').value) || 14;
      var sel = q('.bm-sf-sel');
      var pick = sel ? sel.value : null;
      var rugW = size.w, rugL = size.l;
      var roomWin = rw * 12, roomLin = rl * 12;
      var verdict = 'fit', why = '', needW = 0, needL = 0;

      /* Compare short edge to short edge, so a long rug in a long room is not judged
         against the wrong wall. */
      var roomShort = Math.min(roomWin, roomLin), roomLong = Math.max(roomWin, roomLin);
      var rugShort  = Math.min(rugW, rugL),       rugLong  = Math.max(rugW, rugL);
      var mShort = (roomShort - rugShort) / 2, mLong = (roomLong - rugLong) / 2;
      var margin = Math.min(mShort, mLong);

      /* Physically will not lie flat. Different problem, and the recommendation has to
         go DOWN a size rather than up. */
      if (mShort < 0 || mLong < 0) {
        var down = STOCK.filter(function (s) {
          return s[0] * 12 <= roomShort - 24 && s[1] * 12 <= roomLong - 24;
        }).sort(function (a, b) { return b[0] * b[1] - a[0] * a[1]; })[0] || STOCK[0];
        var over = Math.round(Math.max(-mShort, -mLong) * 2);
        show('no',
          'This rug is too big for that room.',
          'A ' + label + ' will not lie flat in a ' + rw + ' x ' + rl + ' room. It runs about ' + over +
          ' inches past the walls, so it would have to turn up at the edges. In a room this size you want ' +
          'roughly a ' + down[0] + ' x ' + down[1] + ', which leaves a border of bare floor all the way round.',
          plan(rw, rl, rugW / 12, rugL / 12, down[0], down[1]),
          down, true);
        remember(r, rw, rl, pick);
        return;
      }

      if (r === 'living' || r === 'office') {
        var front = r === 'office' ? (DESKS[pick] || 72) : (SOFA[pick] || 84);
        var word  = r === 'office' ? 'desk' : 'sofa';
        needW = front + 24; needL = 90;
        var share = (rugW * rugL) / (roomWin * roomLin);
        if (Math.max(rugW, rugL) < front + 12 || share < 0.25) verdict = 'no';
        else if (margin < 6)  verdict = 'no';
        else if (margin < 12) verdict = 'tight';
        why = { fit: 'In a ' + rw + ' x ' + rl + ' room with a ' + front + ' inch ' + word + ', this rug puts the front legs of the ' + word + ' and both chairs on the pile and leaves about ' + Math.round(margin) + ' inches of bare floor along the long walls. That is the proportion designers aim for.',
                tight: 'In a ' + rw + ' x ' + rl + ' room with a ' + front + ' inch ' + word + ', this leaves only about ' + Math.round(margin) + ' inches of floor along one wall. It will look deliberate rather than wrong, but the room will read fuller.',
                no: 'In a ' + rw + ' x ' + rl + ' room with a ' + front + ' inch ' + word + ', a ' + label + ' reads as an island floating in the middle of the floor with the furniture sitting off it. That is the most common rug regret there is.' }[verdict];
      } else if (r === 'bedroom') {
        var b = BEDS[pick] || BEDS.queen;
        needW = b[0] + 48; needL = b[1] + 48;
        var side = (rugW - b[0]) / 2;
        if (side < 12) verdict = 'no'; else if (side < 24) verdict = 'tight';
        why = { fit: 'With a ' + (pick || 'queen') + ' bed, this rug shows about ' + Math.round(side) + ' inches of wool each side, so you step onto pile getting out of bed.',
                tight: 'With a ' + (pick || 'queen') + ' bed you get about ' + Math.round(side) + ' inches each side. Walkable, but tighter than most people want.',
                no: 'With a ' + (pick || 'queen') + ' bed this rug barely clears the frame, so you would step onto bare floor. You want it reaching about two feet past each side.' }[verdict];
      } else if (r === 'dining') {
        var t = TABLES[pick] || TABLES['6'];
        needW = t[0] + 48; needL = t[1] + 48;
        var clr = Math.min(rugW - t[0], rugL - t[1]) / 2;
        if (clr < 18) verdict = 'no'; else if (clr < 24) verdict = 'tight';
        why = { fit: 'With a table for ' + (pick || 6) + ', chairs stay on the rug when pulled out. About ' + Math.round(clr) + ' inches of clearance on every side.',
                tight: 'About ' + Math.round(clr) + ' inches of clearance. The back chair legs will catch the edge when someone pushes back hard.',
                no: 'Only about ' + Math.round(clr) + ' inches of clearance, so chairs come off the rug when pulled out. Chair legs catching an edge is the thing people hate most in a dining room.' }[verdict];
      } else {
        var hall = parseFloat(pick) || 42;
        needW = hall - 10; needL = roomLin - 12;
        var gap = (hall - Math.min(rugW, rugL)) / 2;
        if (gap < 2) verdict = 'no'; else if (gap > 12) verdict = 'tight';
        why = { fit: 'Leaves about ' + Math.round(gap) + ' inches of floor each side, which is the runner proportion that looks intentional.',
                tight: 'Leaves about ' + Math.round(gap) + ' inches each side, wider than ideal. It will read as a rug in a hallway rather than a runner.',
                no: 'Too wide for a ' + hall + ' inch hallway. It will touch the baseboards.' }[verdict];
      }

      /* On a too-small verdict the recommendation must be larger than the rug in view. */
      var rec = verdict === 'no' ? bestStock(needW, needL, rugShort, rugLong) : bestStock(needW, needL);
      var head = { fit: 'Yes. ' + label + ' is the right rug for this room.',
                   tight: 'It works, but it will sit tight.',
                   no: 'This one is the wrong size for that room.' }[verdict];
      show(verdict, head, why, plan(rw, rl, rugW / 12, rugL / 12,
           verdict === 'no' ? rec[0] : 0, verdict === 'no' ? rec[1] : 0), rec, false);
      remember(r, rw, rl, pick);
    }

    function show(verdict, head, why, planSvg, rec, tooBig) {
      var url = collectionFor(rec[0], rec[1]);
      var h = '<h5>' + head + '</h5><p>' + why + '</p>' + planSvg;
      if (verdict === 'no') {
        h += '<div class="bm-sf-opts">' +
          '<div class="bm-sf-opt"><b>The ' + rec[0] + ' x ' + rec[1] + 's already in New Orleans</b>' +
          '<p>In our warehouse now, and they will actually fit.</p>' +
          '<a class="bm-sf-btn" href="' + url + '">Show me those rugs</a></div>' +
          '<div class="bm-sf-opt"><b>Or have this design woven at ' + rec[0] + ' x ' + rec[1] + '</b>' +
          '<p>Same palette, same wool, same workshop. We send a price first.</p>' +
          '<a class="bm-sf-btn is-ghost" href="/collections/rugs-made-to-order">Made to order</a></div></div>';
        if (!tooBig) h += '<div class="bm-sf-again">Or keep this one in mind for a smaller room.</div>';
      } else {
        h += '<div class="bm-sf-tape">Before you buy, put painter’s tape on the floor at ' + label +
             ' and live with it for an hour. It takes five minutes and it is the only way to be certain.</div>';
        if (verdict === 'tight') h += '<div class="bm-sf-again">Want more breathing room? ' +
          '<a href="' + url + '">See the ' + rec[0] + ' x ' + rec[1] + 's in stock</a>.</div>';
      }
      res.className = 'bm-sf-res is-on v-' + verdict;
      res.innerHTML = h;
      res.setAttribute('role', 'status');
    }

    function remember(r, w, l, pick) {
      try { localStorage.setItem('bm_room', JSON.stringify({ room: r, w: w, l: l, third: pick })); } catch (e) {}
    }

    trigger.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) return;
      var last = null;
      try { last = JSON.parse(localStorage.getItem('bm_room') || 'null'); } catch (e) {}
      if (last) {
        var rr = root.querySelector('input[name="bm-sf-room"][value="' + last.room + '"]');
        if (rr) rr.checked = true;
        if (last.w) q('.bm-sf-w').value = last.w;
        if (last.l) q('.bm-sf-l').value = last.l;
      }
      syncThird();
      if (last && last.third) { var s = q('.bm-sf-sel'); if (s) s.value = last.third; }
    });

    root.querySelectorAll('input[name="bm-sf-room"]').forEach(function (el) {
      el.addEventListener('change', syncThird);
    });
    q('.bm-sf-go').addEventListener('click', function (e) { e.preventDefault(); evaluate(); });
    q('.bm-sf-chip').textContent = 'This rug: ' + label;
    syncThird();
  }

  function boot() {
    document.querySelectorAll('.bm-sf').forEach(function (el) {
      if (el.dataset.bmSfReady) return;
      el.dataset.bmSfReady = '1';
      init(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  /* the theme swaps sections in via the editor and variant listeners */
  document.addEventListener('shopify:section:load', boot);
}());
